import { FormikProps } from 'formik'
import { Maybe } from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'
import { useUpdateCustomTimeRangeCategory } from 'modules/attendance/hooks/useUpdateCustomTimeRangeCategory'

import { centsToMinutes, minutesToCents } from '../timeConverter'

interface Props {
  category: CustomTimeRangeCategory
}

export interface EditCustomTimeRangeCategoryFormType {
  id: number
  rawMinutesInCents: number
  equivalentMinutesInCents: number
  attendanceEmployeesSettingId: number
  timeSettingsCustomTimeRangeCategoryId?: Maybe<number>
}

const EditAttendanceCustomTimeRangeCategoriesForm = ({ category }: Props) => {
  const { update } = useUpdateCustomTimeRangeCategory()

  const initialData = {
    ...category,
    id: category.id,
    attendanceEmployeesSettingId: category.attendanceEmployeesSettingId,
    rawMinutesInCents: centsToMinutes(category.rawMinutesInCents),
    equivalentMinutesInCents: centsToMinutes(category.equivalentMinutesInCents),
  }

  const form: FormikProps<EditCustomTimeRangeCategoryFormType> =
    useForm<EditCustomTimeRangeCategoryFormType>({
      defaultValues: initialData,
      onSubmit: async (data, { setErrors }) => {
        const payload = {
          ...category,
          id: data.id,
          attendanceEmployeesSettingId: data.attendanceEmployeesSettingId,
          rawMinutesInCents: minutesToCents(data.rawMinutesInCents),
          equivalentMinutesInCents: minutesToCents(data.equivalentMinutesInCents),
        }
        const result = await update(payload)
        const handled = handleResult(result, setErrors)
        if (handled.success) {
          data.id === category.id &&
            app.setFlash({
              type: 'correct',
              message: i18n.t('common.saved_successfully'),
            })
          form.resetForm()
        } else {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('time_tracking.settings.time_blocks.categories.modals.name_error'),
          })
        }

        return handled
      },
    })

  return form
}

export default EditAttendanceCustomTimeRangeCategoriesForm
